import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useWatch } from 'react-hook-form';
import { TextInput, SelectInput } from 'react-admin';

const TimezoneInput = (props) => {
  const liveAt = useWatch({ name: 'liveAt' });

  return (
    <Fragment>
      {liveAt === null && <TextInput source="liveAtTimeZone" disabled />}

      {liveAt !== null && (
        <SelectInput
          label="Timezone"
          source="liveAtTimeZone"
          defaultValue="America/Los_Angeles"
          choices={[
            { id: 'Pacific/Honolulu', name: 'Pacific/Honolulu' },
            { id: 'America/Los_Angeles', name: 'America/Los_Angeles' },
            { id: 'America/Phoenix', name: 'America/Phoenix' },
            { id: 'America/Denver', name: 'America/Denver' },
            { id: 'America/Chicago', name: 'America/Chicago' },
            { id: 'America/New_York', name: 'America/New_York' },
          ]}
        />
      )}
    </Fragment>
  );
};

TimezoneInput.propTypes = {
  formvalues: PropTypes.object,
};

export default TimezoneInput;
